import React, { useState } from "react"
import MetaTags from 'react-meta-tags';
import {
    Container,
    Row, Col,
    Card, CardBody,
    Button,
    Input, Label,
    Modal, ModalHeader, ModalBody, ModalFooter,
    FormGroup, FormText, Form
} from "reactstrap"
import Select from "react-select"
import { post, postMultipart } from "../../../helpers/api_helper"
import * as url from "../../../helpers/url_helper"
import moment from "moment";
const FormData = require('form-data');

import cogoToast from "cogo-toast";
import { connect } from "react-redux"

import Lightbox from "react-image-lightbox"
import "react-image-lightbox/style.css"
import axios from "axios";
import ReactHTMLTableToExcel from 'react-html-table-to-excel';

const periods = [
    { label: 'Today', value: 'Today' },
    { label: 'Yesterday', value: 'Yesterday' },
    { label: 'Weekly', value: 'Weekly' },
    { label: 'Monthly', value: 'Monthly' },
    { label: 'Quarterly', value: 'Quarterly' },
    { label: 'Custom', value: 'Custom' },
];

const PpmLogsheet = props => {

    const [loading, setLoading] = React.useState(false);
    const [initializing, setInitializing] = React.useState(false);
    const [mode, setMode] = React.useState('daily');

    const [data, setData] = React.useState([]);
    const [fields, setFields] = React.useState([]);

    // Daily Logsheet dropdown data
    const [assettypes, setAssettypes] = React.useState([]);
    const [assets, setAssets] = React.useState([]); // Shared between modes

    const [assettype, setAssettype] = React.useState(null);
    const [asset, setAsset] = React.useState(null);
    const [activity, setActivity] = React.useState(null);

    // Activity-wise dropdown data
    const [servicetypes, setServicetypes] = React.useState([]);
    const [groups, setGroups] = React.useState([]);
    const [activities, setActivities] = React.useState([]);

    const [servicetype, setServicetype] = React.useState(null);
    const [group, setGroup] = React.useState(null);
    const [selectedAssets, setSelectedAssets] = React.useState([]);
    // const [activity, setActivity] = React.useState(null); // Reuse from above

    const [period, setPeriod] = React.useState({ label: 'Yesterday', value: 'Yesterday' });

    const [startDate, setStartDate] = React.useState(moment().subtract(1, 'day').format('YYYY-MM-DD'));
    const [endDate, setEndDate] = React.useState(moment().subtract(1, 'day').format('YYYY-MM-DD'));

    // Checkboxes
    const [completed, setCompleted] = React.useState(true);
    const [canceled, setCanceled] = React.useState(false);
    const [delayed, setDelayed] = React.useState(false);
    const [missed, setMissed] = React.useState(false);

    const [uom, setUom] = React.useState(false);
    const [fieldRange, setFieldRange] = React.useState(false);
    const [safeRange, setSafeRange] = React.useState(false);
    const [alertValues, setAlertValues] = React.useState(false);
    const [attachments, setAttachments] = React.useState(false);
    const [verifications, setVerifications] = React.useState(false);

    const [verified, setVerified] = React.useState(false);
    const [nonVerified, setNonVerified] = React.useState(true);

    const [showLightbox, setShowLightbox] = React.useState(false);
    const [images, setImages] = React.useState([]);
    const [photoIndex, setPhotoIndex] = React.useState(0);


    // Verification
    const [verifyThese, setVerifyThese] = React.useState([]);
    const [verifyComment, setVerifyComment] = React.useState('');
    const [verifyImages, setVerifyImages] = React.useState([]);
    const [verification, setVerification] = React.useState(null);

    const [activityName, setactivityName] = useState("")


    // console.log('verifyImages', verifyImages);

    const initDaily = () => {

        let initData = {
            property_id: props.filterProperty.id,
            block_id: props.filterBlock.id,
        };

        setInitializing(true);
        post(url.INIT_PPM, initData)
            .then((response) => {
                console.log('RESP', response);
                if (response.status == 200) {
                    setAssettypes(response.data.assettypes);
                    setAssets(response.data.assets);
                }
                else if (response.status == 400) {
                    cogoToast.error('Could not fetch data');
                }
                else {
                    console.log('err::', response);
                    cogoToast.error('Could not fetch data');
                }
                setInitializing(false);
            }, (error) => {
                console.log(error);
                setInitializing(false);
            });

    };


    const initAct = () => {

        let initData = {
            property_id: props.filterProperty.id,
            block_id: props.filterBlock.id,
        };

        setInitializing(true);
        post(url.INITACT_PPM, initData)
            .then((response) => {
                console.log('RESP', response);
                if (response.status == 200) {
                    setServicetypes(response.data.servicetypes);
                    setGroups(response.data.groups);
                    // setActivities(response.data.activities);
                    // setAssets(response.data.assets);
                }
                else if (response.status == 400) {
                    cogoToast.error('Could not fetch data');
                }
                else {
                    console.log('err::', response);
                    cogoToast.error('Could not fetch data');
                }
                setInitializing(false);
            }, (error) => {
                console.log(error);
                setInitializing(false);
            });

    };

    const fetchActivities = (groupId) => {
        let initData = {
            group_id: groupId,
            block_id: props.filterBlock.id,
        };
        setInitializing(true);
        post(url.INIT_PPM_ACT_AVTIVITIES, initData)
            .then((response) => {
                console.log('RESP', response);
                if (response.status == 200) {
                    setActivities(response.data.activities);
                }
                else if (response.status == 400) {
                    cogoToast.error('Could not fetch data');
                }
                else {
                    console.log('err::', response);
                    cogoToast.error('Could not fetch data');
                }
                setInitializing(false);
            }, (error) => {
                console.log(error);
                setInitializing(false);
            });
    };

    const fetchAssets = (activityId) => {
        let initData = {
            activity_id: activityId,
            block_id: props.filterBlock.id,
        };
        setInitializing(true);
        post(url.INIT_PPM_ACT_ASSETS, initData)
            .then((response) => {
                console.log('RESP', response);
                if (response.status == 200) {
                    setAssets(response.data.assets);
                }
                else if (response.status == 400) {
                    cogoToast.error('Could not fetch data');
                }
                else {
                    console.log('err::', response);
                    cogoToast.error('Could not fetch data');
                }
                setInitializing(false);
            }, (error) => {
                console.log(error);
                setInitializing(false);
            });
    };


    const fetchData = () => {

        if (mode == 'daily') {
            if (asset == null) {
                cogoToast.error('Please select an asset');
                return;
            }

            if (activity == null) {
                cogoToast.error('Please select an activity');
                return;
            }
        }
        else if (mode == 'activitywise') {
            if (selectedAssets.length < 1) {
                cogoToast.error('Please select at least one asset');
                return;
            }
        }

        if (!completed && !canceled && !delayed && !missed) {
            cogoToast.error('Please select at least one task status');
            return;
        }

        if (!verified && !nonVerified) {
            cogoToast.error('Please select at least one verification status');
            return;
        }

        let formData = {
            start_date: startDate,
            end_date: endDate,
            activity_id: activity.value,
            property_id: props.filterProperty.id,
            block_id: props.filterBlock.id,
            completed: completed,
            canceled: canceled,
            delayed: delayed,
            missed: missed,
            verified: verified,
            nonverified: nonVerified,
        };

        if (mode == 'daily') {
            formData.asset_id = asset.value;
        }
        else if (mode == 'activitywise') {
            formData.asset_ids = selectedAssets.map(a => a.value);
        }

        setLoading(true);
        post(mode == 'activitywise' ? url.GET_ACTIVITYPPMREPORT : url.GET_DAILYPPMREPORT, formData)
            .then((response) => {
                console.log('RESP', response);
                if (response.status == 200) {
                    let checklists = [];
                    response.data.data.map((cCol, cColIdx) => {
                        cCol.data = JSON.parse(cCol.data);
                        checklists.push(cCol);
                    });
                    setData(checklists);
                    setFields(response.data.fields);
                }
                else if (response.status == 400) {
                    cogoToast.error('Could not fetch report');
                }
                else {
                    console.log('err::', response);
                    cogoToast.error('Could not fetch report');
                }
                setLoading(false);
            }, (error) => {
                console.log(error);
                setLoading(false);
            });

    };



    const doVerify = async () => {

        console.log('verifying');

        console.log(verifyImages);

        // return;

        if (verifyComment.trim() == '') {
            cogoToast.error('Please add a verification comment');
            return;
        }

        let form = await new FormData(document.querySelector('#verForm'));
        await form.set('checklist_ids', verifyThese.map(v => v.id).join(','));
        await form.set('comment', verifyComment);

        for (let i = 0; i < verifyImages.length; i++) {
            form.append(`images[${i}]`, verifyImages[i])
        }


        // if(verifyImages.length > 0) {
        //   if(verifyImages.length > 1) {
        //     // let tempImages = verifyImages.map(v => v[0]);
        //     // await form.append('images', tempImages);
        //     await form.append('images', verifyImages);
        //   }
        //   else {
        //     await form.append('images', [verifyImages[0]]);
        //   }
        // }
        // else {
        //   await form.append('images', []);
        // }
        // await form.append('images', verifyImages[0]);
        // verifyImages.map(async (vImg, vIdx)=>{
        //   console.log(vImg);
        //   await form.append('images'+(vIdx+1), verifyImages);
        // });

        // console.log('form', form, form.getAll('checklist_ids'));

        // let pData = {
        //   checklist_ids: verifyThese.map(v => v.id),
        //   comment: verifyComment,
        //   images: [],
        // }
        // return; 

        setLoading(true);
        postMultipart(url.POST_VERIFICATION, form)
            .then((response) => {
                console.log('ver RESP', response);
                if (response.status == 200) {
                    setVerifyComment('');
                    setVerifyImages([]);
                    setVerifyThese([]);
                    fetchData();
                }
                else if (response.status == 400) {
                    cogoToast.error('Could not perform verification');
                }
                else {
                    console.log('err::', response);
                    cogoToast.error('Could not perform verification');
                }
                setLoading(false);
            }, (error) => {
                console.log(error);
                setLoading(false);
            });

    };


    const resetForm = () => {
        setData([]);
        setAssettype(null);
        setAsset(null);
        setActivity(null);
        setServicetype(null);
        setGroup(null);
        setSelectedAssets([]);
        setPeriod({ label: 'Yesterday', value: 'Yesterday' });
        setStartDate(moment().subtract(1, 'day').format('YYYY-MM-DD'));
        setEndDate(moment().subtract(1, 'day').format('YYYY-MM-DD'));
    }


    const applyMode = (targetMode) => {
        resetForm();
        if (targetMode == 'daily') {
            setServicetypes([]);
            setGroups([]);
            setActivities([]);
            initDaily();
        }
        else {
            setAssets([]);
            setAssettypes([]);
            initAct();
        }
        setMode(targetMode);
    }

    const displayedAssets = assettype ? assets.filter(a => a.assettype_id == assettype.value) : assets;
    const displayedActivities = asset ? asset.activities : [];
    const displayedGroups = servicetype ? groups.filter(g => g.servicetype_id == servicetype.value) : groups;

    // console.log(displayedAssets, assettype);


    React.useEffect(() => {
        if (props.filterBlock) {
            setSelectedAssets([]);
            if (mode == 'activitywise') {
                setSelectedAssets([]);
                setActivity(null);
                setGroup(null);
                setServicetype(null);
                initAct();
            }
            else {
                setActivity(null);
                setAsset(null);
                setAssettype(null);
                initDaily();
            }
        }
    }, [props.filterBlock]);

    // console.log('data', images, photoIndex, showLightbox);

    return (
        <React.Fragment>
            <div className="page-content">
                <MetaTags>
                    <title>Daily Logsheet | Digital Logbook</title>
                </MetaTags>
                <Container fluid>

                    {showLightbox &&
                        <Lightbox
                            mainSrc={images[photoIndex]}
                            nextSrc={images[(photoIndex + 1) % images.length]}
                            prevSrc={images[(photoIndex + images.length - 1) % images.length]}
                            onCloseRequest={() => setShowLightbox(false)}
                            enableZoom={false}
                            onMovePrevRequest={() => {
                                setPhotoIndex((photoIndex + images.length - 1) % images.length);
                            }}
                            onMoveNextRequest={() => {
                                setPhotoIndex((photoIndex + 1) % images.length);
                            }}
                        />
                    }

                    <div className="d-flex justify-content-between align-items-center mb-2">
                        <h3 className="mb-4">PPM Logsheet</h3>
                        <div className="d-flex justify-content-end align-items-center">
                            {/* <ExportCSVButton className="btn btn-secondary me-2" { ...props.csvProps } >Export</ExportCSVButton>
              <Link className="btn btn-primary" to={{pathname: "/activities/new", query: {id: 'new'}}}>Create New</Link> */}

                            <div
                                className="btn-group"
                                role="group"
                                aria-label="Basic example"
                            >
                                <Button
                                    outline={mode == 'daily' ? false : true}
                                    color={mode == 'daily' ? "primary" : "secondary"}
                                    onClick={() => { applyMode('daily'); }}
                                >
                                    Daily
                </Button>{" "}
                                <Button
                                    outline={mode == 'activitywise' ? false : true}
                                    color={mode == 'activitywise' ? "primary" : "secondary"}
                                    onClick={() => { applyMode('activitywise'); }}
                                >
                                    Activity-wise
                </Button>
                            </div>

                        </div>
                    </div>

                    <div className="border border-light p-4 rounded" style={{ backgroundColor: 'rgb(235, 235, 241)' }}>

                        {mode == 'activitywise' ?
                            <Row noGutters>
                                <Col xs={{ size: '3' }} className="">
                                    <label
                                        htmlFor="service-type-input"
                                        className=""
                                    >
                                        Service type
                    </label>
                                    <div className="col-md-10">
                                        <Select
                                            classNamePrefix="select2-selection"
                                            placeholder="All"
                                            title="Service type"
                                            options={servicetypes}
                                            value={servicetype}
                                            isClearable
                                            onChange={e => {
                                                setGroup(null);
                                                setActivity(null);
                                                setSelectedAssets([]);
                                                setServicetype(e);
                                            }}
                                        />
                                    </div>
                                </Col>
                                <Col xs={{ size: '3' }} className="">
                                    <label
                                        htmlFor="service-type-input"
                                        className=""
                                    >
                                        Group
                    </label>
                                    <div className="col-md-10">
                                        <Select
                                            classNamePrefix="select2-selection"
                                            placeholder="Select one..."
                                            title="Group"
                                            options={displayedGroups}
                                            value={group}
                                            onChange={e => {
                                                setActivity(null);
                                                setSelectedAssets([]);
                                                setGroup(e);
                                                fetchActivities(e.value);
                                            }}
                                        />
                                    </div>
                                </Col>
                                <Col xs={{ size: '3' }} className="">
                                    <label
                                        htmlFor="service-type-input"
                                        className=""
                                    >
                                        Activity
                    </label>
                                    <div className="col-md-10">
                                        <Select
                                            classNamePrefix="select2-selection"
                                            placeholder="Select one..."
                                            title="Activity"
                                            options={activities}
                                            value={activity}
                                            onChange={e => {
                                                setSelectedAssets([]);
                                                setAssets([]);
                                                setActivity(e);
                                                setactivityName(e.label)
                                                fetchAssets(e.value);
                                            }}
                                        />
                                    </div>
                                </Col>
                                <Col xs={{ size: '3' }} className="">
                                    <label
                                        htmlFor="service-type-input"
                                        className=""
                                    >
                                        Assets
                    </label>
                                    <div className="col-md-10">
                                        <Select
                                            classNamePrefix="select2-selection"
                                            placeholder="Select..."
                                            title="Assets"
                                            isMulti
                                            noOptionsMessage={() => "No assets found"}
                                            options={assets}
                                            value={selectedAssets}
                                            onChange={e => {
                                                setSelectedAssets(e);
                                            }}
                                        />
                                    </div>
                                </Col>
                            </Row>
                            :
                            <Row noGutters>
                                <Col xs={{ size: '4' }} className="">
                                    <label
                                        htmlFor="service-type-input"
                                        className=""
                                    >
                                        Asset type
                    </label>
                                    <div className="col-md-10">
                                        <Select
                                            classNamePrefix="select2-selection"
                                            placeholder="All"
                                            title="Asset type"
                                            options={assettypes}
                                            value={assettype}
                                            isClearable
                                            onChange={e => {
                                                setActivity(null);
                                                setAsset(null);
                                                setAssettype(e);
                                            }}
                                        />
                                    </div>
                                </Col>
                                <Col xs={{ size: '4' }} className="">
                                    <label
                                        htmlFor="service-type-input"
                                        className=""
                                    >
                                        Asset
                    </label>
                                    <div className="col-md-10">
                                        <Select
                                            classNamePrefix="select2-selection"
                                            placeholder="Select one..."
                                            title="Asset"
                                            options={displayedAssets}
                                            value={asset}
                                            onChange={e => {
                                                setActivity(null);
                                                setAsset(e);
                                            }}
                                        />
                                    </div>
                                </Col>
                                <Col xs={{ size: '4' }} className="">
                                    <label
                                        htmlFor="service-type-input"
                                        className=""
                                    >
                                        Activity
                    </label>
                                    <div className="col-md-10">
                                        <Select
                                            classNamePrefix="select2-selection"
                                            placeholder="Select one..."
                                            title="Activity"
                                            options={displayedActivities}
                                            value={activity}
                                            onChange={e => {
                                                setActivity(e);
                                                setactivityName(e.label)
                                            }}
                                        />
                                    </div>
                                </Col>
                            </Row>
                        }


                        <Row noGutters className="mt-4">
                            <Col xs={{ size: '4' }} className="">
                                <label
                                    htmlFor="service-type-input"
                                    className=""
                                >
                                    Period
                            </label>
                                <div className="col-md-10">
                                    <Select
                                        classNamePrefix="select2-selection"
                                        placeholder="Select one..."
                                        title="Period"
                                        options={periods}
                                        value={period}
                                        onChange={e => {
                                            switch (e.value) {
                                                case 'Today':
                                                    setStartDate(moment().format('YYYY-MM-DD'));
                                                    setEndDate(moment().format('YYYY-MM-DD'));
                                                    break;
                                                case 'Yesterday':
                                                    setStartDate(moment().subtract(1, 'day').format('YYYY-MM-DD'));
                                                    setEndDate(moment().subtract(1, 'day').format('YYYY-MM-DD'));
                                                    break;
                                                case 'Weekly':
                                                    setStartDate(moment().subtract(1, 'week').format('YYYY-MM-DD'));
                                                    setEndDate(moment().format('YYYY-MM-DD'));
                                                    break;
                                                case 'Monthly':
                                                    setStartDate(moment().subtract(1, 'month').format('YYYY-MM-DD'));
                                                    setEndDate(moment().format('YYYY-MM-DD'));
                                                    break;
                                                case 'Quarterly':
                                                    setStartDate(moment().subtract(3, 'month').format('YYYY-MM-DD'));
                                                    setEndDate(moment().format('YYYY-MM-DD'));
                                                    break;
                                                default:
                                                    console.log('custom', e);
                                            }
                                            setPeriod(e);
                                        }}
                                    />
                                </div>
                            </Col>
                            <Col xs={{ size: '4' }} className="">
                                <label
                                    htmlFor="start-date-input"
                                    className=""
                                >
                                    From
                            </label>
                                <div className="col-md-10">
                                    <input
                                        className="form-control"
                                        type="date"
                                        disabled={period.value !== 'Custom'}
                                        id="start-date-input"
                                        value={startDate} onChange={e => { setStartDate(e.target.value); }}
                                    />
                                </div>
                            </Col>
                            <Col xs={{ size: '4' }} className="">
                                <label
                                    htmlFor="end-date-input"
                                    className=""
                                >
                                    To
                            </label>
                                <div className="col-md-10">
                                    <input
                                        className="form-control"
                                        type="date"
                                        disabled={period.value !== 'Custom'}
                                        id="end-date-input"
                                        value={endDate} onChange={e => { setEndDate(e.target.value); }}
                                    />
                                </div>
                            </Col>
                        </Row>


                        <Row noGutters className="mt-4" style={{ paddingTop: 8 }}>
                            {/* <Col xs={{ size: '1' }} className="">
                          </Col> */}
                            {/* <Col xs={{ size: '4' }} className="">
                            <div className="">
                              <p className="fs-5 fw-bold">Alerts</p>
                              <div className="form-check form-switch form-switch-md">
                                  <input type="checkbox" id="checkbox_1" className="form-check-input checkbox"
                                  //   checked={props.isPreloader}
                                  //   onChange={() => {  }}
                                  />
                                  <label className="form-check-label" htmlFor="checkbox_1">
                                  Normal
                                  </label>
                              </div>
                              <div className="form-check form-switch form-switch-md">
                                  <input type="checkbox" id="checkbox_1" className="form-check-input checkbox"
                                  //   checked={props.isPreloader}
                                  //   onChange={() => {  }}
                                  />
                                  <label className="form-check-label" htmlFor="checkbox_1">
                                  Alert
                                  </label>
                              </div>
                              <div className="form-check form-switch form-switch-md">
                                  <input type="checkbox" id="checkbox_1" className="form-check-input checkbox"
                                  //   checked={props.isPreloader}
                                  //   onChange={() => {  }}
                                  />
                                  <label className="form-check-label" htmlFor="checkbox_1">
                                  Ticket
                                  </label>
                              </div>
                            </div>
                        </Col> */}
                            <Col xs={{ size: '6' }} className="d-flex ">
                                <div className="">
                                    <p className="fs-5 fw-bold">Task status</p>
                                    <div className="form-check form-switch form-switch-md">
                                        <input type="checkbox" id="checkbox_completed" className="form-check-input checkbox"
                                            checked={completed}
                                            onChange={() => { setCompleted(!completed); }}
                                        />
                                        <label className="form-check-label" htmlFor="checkbox_completed">
                                            Completed
                                  </label>
                                    </div>
                                    <div className="form-check form-switch form-switch-md">
                                        <input type="checkbox" id="checkbox_canceled" className="form-check-input checkbox"
                                            checked={canceled}
                                            onChange={() => { setCanceled(!canceled); }}
                                        />
                                        <label className="form-check-label" htmlFor="checkbox_canceled">
                                            Canceled
                                  </label>
                                    </div>
                                    <div className="form-check form-switch form-switch-md">
                                        <input type="checkbox" id="checkbox_delayed" className="form-check-input checkbox"
                                            checked={delayed}
                                            onChange={() => { setDelayed(!delayed); }}
                                        />
                                        <label className="form-check-label" htmlFor="checkbox_delayed">
                                            Delayed
                                  </label>
                                    </div>
                                    <div className="form-check form-switch form-switch-md">
                                        <input type="checkbox" id="checkbox_missed" className="form-check-input checkbox"
                                            checked={missed}
                                            onChange={() => { setMissed(!missed); }}
                                        />
                                        <label className="form-check-label" htmlFor="checkbox_missed">
                                            Missed
                                  </label>
                                    </div>
                                </div>
                            </Col>
                            <Col xs={{ size: '6' }} className="">
                                <div className="">
                                    <p className="fs-5 fw-bold">Verification</p>
                                    <div className="form-check form-switch form-switch-md">
                                        <input type="checkbox" id="checkbox_verified" className="form-check-input checkbox"
                                            checked={verified}
                                            onChange={() => { setVerified(!verified); }}
                                        />
                                        <label className="form-check-label" htmlFor="checkbox_verified">
                                            Verified
                                </label>
                                    </div>
                                    <div className="form-check form-switch form-switch-md">
                                        <input type="checkbox" id="checkbox_nonverified" className="form-check-input checkbox"
                                            checked={nonVerified}
                                            onChange={() => { setNonVerified(!nonVerified); }}
                                        />
                                        <label className="form-check-label" htmlFor="checkbox_nonverified">
                                            Non-verified
                                </label>
                                    </div>
                                </div>
                            </Col>
                        </Row>

                        <div className="text-center mt-5 mb-2">
                            <Button
                                color="primary"
                                className="btn btn-secondary me-2"
                                onClick={() => {
                                    resetForm();
                                }}
                            >
                                Reset
                        </Button>
                            <Button
                                color="primary"
                                className="btn btn-primary ms-2"
                                onClick={() => {
                                    fetchData();
                                }}
                            >
                                Submit
                        </Button>
                        </div>
                    </div>

















                    <div className="mt-4">
                        {/* { (startDate == undefined || endDate == undefined) &&
          <div>
            Please select start and end dates
          </div>
          }
          { (startDate !== undefined && endDate !== undefined) && */}
                        <div>
                            {loading ?
                                <div>Loading..</div>
                                :
                                <div>
                                    {data.length < 1 ?
                                        <div className="text-center p-5 text-muted fst-italic">No data</div>
                                        :
                                        <div className="">
                                            <div className="py-2 px-3" style={{ backgroundColor: 'rgba(73, 84, 103, 0.06)' }}>
                                                <div className="d-flex flex-row justify-content-between align-items-center">
                                                    <div className="flex-1">
                                                        <div className="form-check form-switch form-switch-md">
                                                            <input type="checkbox" id="checkbox_uom" className="form-check-input checkbox"
                                                                checked={uom}
                                                                onChange={() => { setUom(!uom); }}
                                                            />
                                                            <label className="form-check-label" htmlFor="checkbox_uom">
                                                                UOM
                              </label>
                                                        </div>
                                                    </div>
                                                    <div className="flex-1">
                                                        <div className="form-check form-switch form-switch-md">
                                                            <input type="checkbox" id="checkbox_fieldrange" className="form-check-input checkbox"
                                                                checked={fieldRange}
                                                                onChange={() => { setFieldRange(!fieldRange); }}
                                                            />
                                                            <label className="form-check-label" htmlFor="checkbox_fieldrange">
                                                                Field Range
                              </label>
                                                        </div>
                                                    </div>
                                                    <div className="flex-1">
                                                        <div className="form-check form-switch form-switch-md">
                                                            <input type="checkbox" id="checkbox_saferange" className="form-check-input checkbox"
                                                                checked={safeRange}
                                                                onChange={() => { setSafeRange(!safeRange); }}
                                                            />
                                                            <label className="form-check-label" htmlFor="checkbox_saferange">
                                                                Safe Range
                              </label>
                                                        </div>
                                                    </div>
                                                    <div className="flex-1">
                                                        <div className="form-check form-switch form-switch-md">
                                                            <input type="checkbox" id="checkbox_alertvalues" className="form-check-input checkbox"
                                                                checked={alertValues}
                                                                onChange={() => { setAlertValues(!alertValues); }}
                                                            />
                                                            <label className="form-check-label" htmlFor="checkbox_alertvalues">
                                                                Alert Values
                              </label>
                                                        </div>
                                                    </div>
                                                    <div className="flex-1">
                                                        <div className="form-check form-switch form-switch-md">
                                                            <input type="checkbox" id="checkbox_attachments" className="form-check-input checkbox"
                                                                checked={attachments}
                                                                onChange={() => { setAttachments(!attachments); }}
                                                            />
                                                            <label className="form-check-label" htmlFor="checkbox_attachments">
                                                                Attachments
                              </label>
                                                        </div>
                                                    </div>
                                                    <div className="flex-1">
                                                        <div className="form-check form-switch form-switch-md">
                                                            <input type="checkbox" id="checkbox_attachments" className="form-check-input checkbox"
                                                                checked={verifications}
                                                                onChange={() => { setVerifications(!verifications); }}
                                                            />
                                                            <label className="form-check-label" htmlFor="checkbox_attachments">
                                                                Verification
                              </label>
                                                        </div>
                                                    </div>
                                                    <div className="flex-1 text-end">
                                                        <div>
                                                            <ReactHTMLTableToExcel
                                                                className="btn btn-info"
                                                                table="emp"
                                                                filename="ReportExcel"
                                                                sheet="Sheet"
                                                                buttonText="Export" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <Card>
                                                <CardBody>
                                                    <div className="table-rep-plugin">
                                                        <div className="table-responsive mb-0"
                                                            data-pattern="priority-columns">
                                                            <table className="table" id="emp">
                                                                <tr hidden>
                                                                    <td colSpan="3"><h6>Activity Name:{activityName}</h6></td>
                                                                    <td colSpan="5"><h6>Period : From-{startDate} To-{endDate}</h6></td>
                                                                </tr>
                                                                <thead>
                                                                    <tr>
                                                                        <th>Scheduled date</th>
                                                                        <th>Done at</th>
                                                                        {fields.map((field, fieldIdx) => (
                                                                            <th key={fieldIdx}>{field.label}</th>
                                                                        ))}
                                                                        <th>Task done by</th>
                                                                        {verifications &&
                                                                            <th>
                                                                                Verified at
                                    </th>
                                                                        }
                                                                        {verifications &&
                                                                            <th>
                                                                                Verified by
                                    </th>
                                                                        }
                                                                        {verifications &&
                                                                            <th>
                                                                                Verification comment
                                    </th>
                                                                        }
                                                                        <th>Verification</th>
                                                                        {attachments &&
                                                                            <th>
                                                                                Attachments
                                    </th>
                                                                        }
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {uom &&
                                                                        <tr className="row-filters">
                                                                            <td className="fst-italic" style={{ fontWeight: '500' }} colSpan="2">Unit of Measure</td>
                                                                            {fields.map((field, fieldIdx) => (
                                                                                <td key={fieldIdx} className="fst-italic">{field.unit_of_measure || '-'}</td>
                                                                            ))}
                                                                            <td>&nbsp;</td>
                                                                            {verifications && <td>&nbsp;</td>}
                                                                            {verifications && <td>&nbsp;</td>}
                                                                            {verifications && <td>&nbsp;</td>}
                                                                            <td>&nbsp;</td>
                                                                            {attachments &&
                                                                                <td>
                                                                                    &nbsp;
                                    </td>
                                                                            }
                                                                        </tr>
                                                                    }
                                                                    {fieldRange &&
                                                                        <tr className="row-filters">
                                                                            <td className="fst-italic" style={{ fontWeight: '500' }} colSpan="2">Field Range</td>
                                                                            {fields.map((field, fieldIdx) => (
                                                                                <td className="fst-italic" key={fieldIdx}>
                                                                                    {(field.min || field.max) ? ((field.min || 'n/a') + '-' + (field.max || 'n/a')) : '-'}
                                                                                </td>
                                                                            ))}
                                                                            <td>&nbsp;</td>
                                                                            {verifications && <td>&nbsp;</td>}
                                                                            {verifications && <td>&nbsp;</td>}
                                                                            {verifications && <td>&nbsp;</td>}
                                                                            <td>&nbsp;</td>
                                                                            {attachments &&
                                                                                <td>
                                                                                    &nbsp;
                                    </td>
                                                                            }
                                                                        </tr>
                                                                    }
                                                                    {safeRange &&
                                                                        <tr className="row-filters">
                                                                            <td className="fst-italic" style={{ fontWeight: '500' }} colSpan="2">Safe Range</td>
                                                                            {fields.map((field, fieldIdx) => (
                                                                                <td className="fst-italic" key={fieldIdx}>
                                                                                    {(field.warning_min || field.warning_max) ? ((field.warning_min || 'n/a') + '-' + (field.warning_max || 'n/a')) : '-'}
                                                                                </td>
                                                                            ))}
                                                                            <td>&nbsp;</td>
                                                                            {verifications && <td>&nbsp;</td>}
                                                                            {verifications && <td>&nbsp;</td>}
                                                                            {verifications && <td>&nbsp;</td>}
                                                                            <td>&nbsp;</td>
                                                                            {attachments &&
                                                                                <td>
                                                                                    &nbsp;
                                    </td>
                                                                            }
                                                                        </tr>
                                                                    }
                                                                    {alertValues &&
                                                                        <tr className="row-filters">
                                                                            <td className="fst-italic" style={{ fontWeight: '500' }} colSpan="2">Alert on</td>
                                                                            {fields.map((field, fieldIdx) => (
                                                                                <td key={fieldIdx} className="fst-italic">{field.alert_on || '-'}</td>
                                                                            ))}
                                                                            <td>&nbsp;</td>
                                                                            {verifications && <td>&nbsp;</td>}
                                                                            {verifications && <td>&nbsp;</td>}
                                                                            {verifications && <td>&nbsp;</td>}
                                                                            <td>&nbsp;</td>
                                                                            {attachments &&
                                                                                <td>
                                                                                    &nbsp;
                                    </td>
                                                                            }
                                                                        </tr>
                                                                    }

                                                                    {data.map((tdRow, tdRowIdx) => (
                                                                        <tr key={tdRowIdx}>
                                                                            <td>{moment(tdRow.ppmtask.end_date).format('DD MMM YYYY')}</td>
                                                                            <td>{tdRow.ppmtask.end_date ? moment(tdRow.ppmtask.ended_at).format('DD MMM YYYY hh:mm a') : '-'}</td>
                                                                            {tdRow.data.map((tdCol, tdColIdx) => (
                                                                                <td key={tdColIdx}>{tdCol.val}</td>
                                                                            ))}
                                                                            <td>{tdRow.ppmtask.user ? tdRow.ppmtask.user.name : '-'}</td>

                                                                            { verifications &&
                                                                                <td>
                                                                                    {tdRow.ppmverifications.length < 1 ? '-' :
                                                                                        moment(tdRow.ppmverifications[tdRow.ppmverifications.length - 1].created_at).format('DD MMM YYYY hh:mm a')}
                                                                                </td>
                                                                            }
                                                                            { verifications &&
                                                                                <td>
                                                                                    {tdRow.ppmverifications.length < 1 ? '-' :
                                                                                        tdRow.ppmverifications[tdRow.ppmverifications.length - 1].user.name}
                                                                                </td>
                                                                            }
                                                                            { verifications &&
                                                                                <td>
                                                                                    {tdRow.ppmverifications.length < 1 ? '-' :
                                                                                        (tdRow.ppmverifications[tdRow.ppmverifications.length - 1].comment.substring(0, 20) + (tdRow.ppmverifications[tdRow.ppmverifications.length - 1].comment.length > 20 ? '..' : ''))}
                                                                                </td>
                                                                            }

                                                                            <td>{tdRow.ppmverifications.length > 0 ?
                                                                                <Button color="success" size="sm" onClick={() => {
                                                                                    setVerification(tdRow)
                                                                                    console.log("inside view button", tdRow)
                                                                                }}>
                                                                                    View
                                    </Button>
                                                                                :
                                                                                <Button color="info" size="sm" onClick={() => {
                                                                                    setVerifyThese([{ id: tdRow.id, name: tdRow.ppmactivity.name }])
                                                                                }}>Verify</Button>
                                                                            }</td>
                                                                            { attachments &&
                                                                                <td width={80}>
                                                                                    {tdRow.ppmchecklistimages.length > 0 &&
                                                                                        <div className="link-attachments d-flex flex-row"
                                                                                            onClick={() => {
                                                                                                let imgs = [];
                                                                                                tdRow.ppmchecklistimages.map((cImg, cImgIdx) => {
                                                                                                    imgs.push("https://apilogbook.six30labs.com/storage/ppm_verification/" + cImg.filename);
                                                                                                });
                                                                                                setImages(imgs);
                                                                                                setPhotoIndex(0);
                                                                                                setShowLightbox(true);
                                                                                            }}
                                                                                        >
                                                                                            <i className="bx bx-image" style={{ color: '#667CE8', fontSize: 18, marginRight: 5, }}></i>
                                                                                            {tdRow.ppmchecklistimages.length}
                                                                                        </div>}
                                                                                </td>}
                                                                        </tr>
                                                                    ))}
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </CardBody>
                                            </Card>
                                        </div>

                                    }
                                </div>
                            }
                        </div>
                        {/* } */}
                    </div>

                    {verifyThese.length > 0 &&
                        <Modal isOpen={verifyThese.length > 0} centered>
                            <ModalHeader toggle={() => { setVerifyThese([]); }}>Verify Checklists</ModalHeader>
                            <ModalBody>
                                <p className="fw-bold mb-2">Add Verification for:</p>
                                <div className="mb-5">
                                    <ul>
                                        {verifyThese.map((vItem, vIdx) => (
                                            <li key={vIdx} className="">
                                                {vItem.name}
                                            </li>
                                        ))}
                                    </ul>
                                </div>

                                <form encType="multipart/form-data" id="verForm">
                                    <FormGroup>
                                        <Label>Verification comment</Label>
                                        <Input
                                            type="textarea"
                                            id="textarea"
                                            value={verifyComment}
                                            onChange={e => {
                                                setVerifyComment(e.target.value)
                                            }}
                                            maxLength="225"
                                            rows="3"
                                            placeholder="Start typing..."
                                        />
                                    </FormGroup>


                                    <FormGroup className="mt-4">
                                        <Label for="exampleFile" className="col-form-label">
                                            Images (Optional)
                  </Label>
                                        <div className="mt-1 mb-1">
                                            <Input
                                                id="exampleFile"
                                                // name="file"
                                                type="file"
                                                multiple={true}
                                                // value={verifyImages}
                                                onChange={e => {
                                                    console.log('file e', e.target.files, e.target.value);
                                                    setVerifyImages(e.target.files);
                                                }}
                                            />
                                        </div>
                                        <FormText>
                                            Hold Ctrl to select multiple image files
                  </FormText>
                                    </FormGroup>

                                </form>

                            </ModalBody>
                            <ModalFooter>
                                <Button color="secondary" onClick={() => {
                                    setVerifyComment('');
                                    setVerifyThese([]);
                                }}>Cancel</Button>{' '}
                                <Button color="primary" onClick={() => {
                                    doVerify();
                                }}>Submit</Button>
                            </ModalFooter>
                        </Modal>
                    }


                    {verification &&
                        <Modal isOpen={verification !== null} centered>
                            <ModalHeader toggle={() => { setVerification(null); }}>Verification Log</ModalHeader>
                            <ModalBody>
                                <p className="fw-bold mb-2">Verification for:</p>
                                <div className="mb-5">
                                    {verification.ppmactivity.name}
                                </div>

                                {verification.ppmverifications.length > 0 &&
                                    <div>
                                        <h5 className="h5 mt-5 mb-3">Verification History</h5>
                                        <div>
                                            <table className="table table-striped">
                                                <thead>
                                                    <tr>
                                                        <th>Comment</th>
                                                        <th>Verified by</th>
                                                        <th>Verified at</th>
                                                        <th>Images</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {verification.ppmverifications.map((vItem, vIdx) => (
                                                        <tr key={vIdx}>
                                                            <td>{vItem.comment}</td>
                                                            <td>Admin</td>
                                                            <td>{moment(vItem.created_at).format('DD MMM YYYY hh:mm a')}</td>
                                                            <td>{
                                                                vItem.ppmverificationimages.length > 0 ?
                                                                    <div className="link-attachments d-flex flex-row"
                                                                        onClick={() => {
                                                                            let imgs = [];
                                                                            vItem.ppmverificationimages.map((cImg, cImgIdx) => {
                                                                                imgs.push("https://apilogbook.six30labs.com/storage/ppm_verification/" + cImg.filename);
                                                                            });
                                                                            setImages(imgs);
                                                                            setPhotoIndex(0);
                                                                            setShowLightbox(true);
                                                                        }}
                                                                    >
                                                                        <i className="bx bx-image" style={{ color: '#667CE8', fontSize: 18, marginRight: 5, }}></i>
                                                                        {vItem.ppmverificationimages.length}</div> :
                                                                    <span className="text-muted">-</span>
                                                            }</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                }


                            </ModalBody>
                            <ModalFooter>
                                {/* <Button color="primary" onClick={() => {
                                    setVerifyThese([{ id: verification.id, name: verification.ppmactivity.name }]);
                                    setVerification(null);
                                }}>Add Verification</Button> */}
                                <Button color="secondary" onClick={() => {
                                    setVerification(null);
                                }}>Close</Button>{' '}
                            </ModalFooter>
                        </Modal>
                    }


                </Container>
            </div>


        </React.Fragment>
    )
}

const mapStatetoProps = (state) => {
    const {
        filterBlock,
        filterProperty
    } = state.filters
    return { filterBlock, filterProperty }
}

export default connect(mapStatetoProps)(PpmLogsheet)